(function () {
	'use strict';

	window.js = window.js || {};

	js.listview = (function () {
		var
			_domElm;

		function initialize(domElm) {
			_domElm = domElm;

			// guard to make sure that image heights are not set to match the content on phablets or smaller devices.
			if (mq.smallerThanPhablet.matches) {
				return;
			}

			var
				entries = Array.prototype.slice.call(_domElm.querySelectorAll('.js-item'));

			entries.forEach(function (entry) {
				var img = entry.querySelector('.js-img');
				if (img.complete && img.src) {
					loaded.call(img, entry, img)
				} else {
					img.src = img.dataset.src;
					img.addEventListener('load', loaded.bind(img, entry, img));
				}
			});
			//console.log(entries);

		}

		function loaded(entry, img) {
			var
				content = entry.querySelector('.js-content'),
				contentHeight = content.getBoundingClientRect().height,
				imgHeight = img.getBoundingClientRect().height;

			if (contentHeight < imgHeight) {
				entry.querySelector('.js-img-container').style.height = contentHeight + 'px';
				img.style.height = imgHeight + 'px';
			}
		}

		return {
			initialize: initialize
		};
	})();



})();